import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import useLogout from '../hooks/useLogout';
import axiosService from '../utils/axios';
import { Mail, Lock, CheckCircle, AlertCircle, ArrowLeft } from 'lucide-react';
import { ReactComponent as LOCKICON } from '../assets/images/ForgottPass.svg'


const FORGOTPASSWORD_URL = "/contactcentre/password-reset/";

const ForgotPassword = () => {

    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const onSuccess = () => {
        alert('Password reset successful!');
        navigate('/login');
    }

    const onBack = () => {
        navigate('/login')
    }
    const { } = useLogout();

    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        if (!email.trim()) return;

        setLoading(true);
        setError('');
        setMessage('');

        try {
            const response = await axiosService.post(FORGOTPASSWORD_URL,
                { email },
                { withCredentials: true }
            );
            const data = response.data;
            if (response.statusText == "OK") {
                setMessage(data.message);
                onSuccess();
            } else {
                setError(data.error || 'Something went wrong');
            }
        } catch (err) {
            setError('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <img src={require('../assets/images/wave.jpg')} style={{ zIndex: '-1' }} className="fixed hidden lg:block inset-0 h-full" />
            <div className="w-screen h-screen flex flex-col justify-center items-center lg:grid lg:grid-cols-2" >
                <LOCKICON className="hidden lg:block w-auto h-[30rem] scale-125 hover:scale-110 transition-all duration-500 transform mx-auto fill-black" />
                <div className="min-h-screen bg-gradient-to-br to-indigo-100 flex items-center justify-center p-4">
                    <div className="bg-white rounded-xl shadow-2xl p-8 w-full max-w-md">
                        <div className="text-center mb-8">
                            <div className="bg-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Lock className="w-8 h-8 text-white" />
                            </div>
                            <h2 className="text-2xl font-bold text-gray-800 mb-2">Forgot Password?</h2>
                            <p className="text-gray-600">Enter your email address and we'll send you a link to reset your password.</p>
                        </div>

                        {message && (
                            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 flex items-center">
                                <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                                <p className="text-green-800">{message}</p>
                            </div>
                        )}

                        {error && (
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex items-center">
                                <AlertCircle className="w-5 h-5 text-red-500 mr-3" />
                                <p className="text-red-800">{error}</p>
                            </div>
                        )}

                        <div className="space-y-6">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Email Address
                                </label>
                                <div className="relative">
                                    <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                                    <input
                                        type="email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                        placeholder="Enter your email"
                                        onKeyPress={(e) => e.key === 'Enter' && handleSubmit(e)}
                                    />
                                </div>
                            </div>

                            <button
                                onClick={handleSubmit}
                                disabled={loading}
                                className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center"
                            >
                                {loading ? (
                                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                                ) : (
                                    'Send Reset Link'
                                )}
                            </button>
                        </div>

                        <div className="mt-6 text-center">
                            <button
                                onClick={onBack}
                                className="text-blue-600 hover:text-blue-800 font-medium flex items-center justify-center mx-auto transition-colors"
                            >
                                <ArrowLeft className="w-4 h-4 mr-1" />
                                Back to Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPassword
